import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import {
    applyFeatureSelection, changeRoom,
    initializePromotion, setCurrentConfigCode, setCurrentUnit, setSnackbarMessage, setUnitUsers, updateTotalPrice,
} from '../model/configuratorSlice';
import { EndPoints, PromotionStatus, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { DownloadTokenAuth } from '../auth/DownloadToken';
import { RequestBudgetTokenAuth } from '../auth/RequetBudgetToken';

export default function GenerationService() {
    const { promotionSlug } = useParams();
    const { rooms } = useSelector(state => state.configurator);
    const dispatch = useDispatch();

    return useMutation(['generationQuery'], (payload) => {
        const unitId = payload.id_units;
        const { code, isPublic } = payload;

        const generationUrl = isPublic
            ? `${EndPoints.PublicGeneration}/${promotionSlug}/code/${code}/generation`
            : `${EndPoints.Generation}/${promotionSlug}/unit/${unitId}/code/${code}/generation`;

        axios
            .get(generationUrl)
            .then((response) => {
                console.log('response');
                dispatch(initializePromotion(response.data.configuration));
                dispatch(applyFeatureSelection(response.data.selection.feature_selection));
                dispatch(setCurrentConfigCode(code));
                dispatch(updateTotalPrice());
                dispatch(changeRoom(rooms[0].id));
                dispatch(setCurrentUnit(response.data.unitWithUsers));
                dispatch(setUnitUsers(response.data.unitWithUsers));
            })
            .catch((error) => {
                console.log(error);
            });
    });
}
